<!-- the register component template contains a simple registration form with fields for
first name, last name, username and password. It displays validation messages for invalid fields
when the submit button is clicked. On submit the register() method is called if the form is valid. -->

<form [formGroup]="registerForm" (ngSubmit)="onRegister()">

    <p>
        Sollte Ihr Institut hier nicht aufgelistet sein, senden Sie uns bitte
        eine <a href="mailto:{{ supportContact }}"> Nachricht</a>.
    </p>

    <div class="mibi-form-group">
        <mibi-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Institut</mat-label>
                <input
                    type="text"
                    matInput
                    placeholder="Wählen Sie Ihr Institut"
                    formControlName="institution"
                    autocomplete="off"
                    required
                    [matAutocomplete]="autoGroup"
                />
                <mat-error>Muss ein gültiges Institut sein.</mat-error>
                <mat-autocomplete #autoGroup="matAutocomplete">
                    <mat-option
                        class="mibi-register-mat-option"
                        *ngFor="let institution of filteredOptions$ | async"
                        [value]="institution"
                    >{{ institution }}</mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </mibi-form-field>
    </div>

    <div class="mibi-form-group">
        <mibi-form-field>
            <mat-form-field>
                <mat-label>Vorname</mat-label>
                <input
                    matInput
                    placeholder="Geben Sie Ihren Vornamen ein"
                    name="firstName"
                    formControlName="firstName"
                    required
                />
            </mat-form-field>
        </mibi-form-field>

        <mibi-form-field>
            <mat-form-field>
                <mat-label>Nachname</mat-label>
                <input
                    matInput
                    placeholder="Geben Sie Ihren Nachnamen ein"
                    name="lastName"
                    formControlName="lastName"
                    required
                />
            </mat-form-field>
        </mibi-form-field>
    </div>

    <div class="mibi-form-group">
        <mibi-form-field>
            <mat-form-field>
                <mat-label>E-Mail</mat-label>
                <input 
                    matInput
                    placeholder="Geben Sie Ihre E-Mail-Adresse ein"
                    name="email"
                    formControlName="email"
                    required
                />
                <mat-error *ngIf="registerForm.controls.email?.errors?.email">
                    Muss eine gültige E-Mail sein.
                </mat-error>
            </mat-form-field>
        </mibi-form-field>
    </div>

    <mibi-password></mibi-password>

    <div class="mibi-register-actions">
        <a
            class="mibi-register-actions__button"
            mat-button
            color="primary"
            [routerLink]="[userLinks.login]"
        >Zurück</a>
        <button
            class="mibi-register-actions__button"
            mat-flat-button
            color="accent"
            type="submit"
            [disabled]="!registerForm.valid"
        >Registrieren</button>
    </div>
</form>